import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { parsingRules } from '../../../../../../redux/parsing-rules/action';
import { deepCopy } from '../../../../../../common/services/common.service';
import PageLoader from '../../../../../../components/PageLoader';
import * as R from 'ramda';
import ParsingRuleComponent from '../components/parsing-rule.component';
import { selectParsingRulesQueryItems } from '../../../../../../redux/parsing-rules/selector';
import { selectOrganizationUnitsListItems } from '../../../../../../redux/organizationUnits/selector';
import { organizationUnits } from '../../../../../../redux/organizationUnits/action';
import { selectTenantFunctionsListItems } from '../../../../../../redux/tenant-functions/selector';
import { tenantFunctions } from '../../../../../../redux/tenant-functions/action';

let currentChange: any = {}
const ManagementParsingRule = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const queryItems = useSelector(selectParsingRulesQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const organizationUnitsLists = useSelector(selectOrganizationUnitsListItems)
  const tenantfunctionsLists = useSelector(selectTenantFunctionsListItems)
  const [
    parsingRule,
    setParsingRule
  ] = useState<any>([])
  const [
    fieldConversions,
    setFieldConversions
  ] = useState<any>([])
  const fetchRecordById = () => {
    dispatch(parsingRules.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/system/service/parsing-rules/query`, entity: 'parsingRules', jsonData: {

        Records: [
          {


            "Id": parmas?.id



          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    })

  }
  console.log('parsingRule', parsingRule)

  useEffect(
    () => {
      dispatch(organizationUnits.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`, entity: 'organizationUnits', jsonData: {} }))
        .then(() => {
          dispatch(tenantFunctions.list({
            url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/entities/list`, entity: 'tenantFunctions', jsonData: {



            }
          }))
        })
        .then(() => {

          if (parmas?.id > 0) {
            fetchRecordById()
            setIsLoading(false)
          }
          else {
            const localSelectedService = addNewRow({ selectedServiceArg: fieldConversions });
            setFieldConversions(localSelectedService)

            setIsLoading(false)
          }
        })
    }
    ,
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setParsingRule(queryItems?.result?.items)
        const localSelectedService = addNewRow({ selectedServiceArg: queryItems?.result?.items?.Options?.FieldConversions });
        setFieldConversions(localSelectedService)
      }
    },
    [isQuery]
  )

  const handleInnerBasicFormChange: any = (event: any, field: string) => {
    setParsingRule({ ...parsingRule, [field]: event });
  }
  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setParsingRule({ ...parsingRule, [fields[0]]: value });
  }
  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(fieldConversions);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setFieldConversions(items);
  }
  const deleteSelectedService = async (Item: any, index: any) => {
    if (Item.Id === 0) {
      fieldConversions?.splice(
        index,
        1
      )
    }
  }
  const addNewRow = ({ selectedServiceArg }: any) => {
    const localSelectedservice = deepCopy(selectedServiceArg)
    const newRowFieldConversion = {
      Id: 0,
      InputFieldIndex: '',
      InputFieldType: '',
      OutputFieldIndex: '',
      OutputFieldType: '',
      OutputHeaderText: ''

    }
    if (localSelectedservice.length === 0 ||
      localSelectedservice[localSelectedservice?.length - 1]?.InputFieldIndex !== ''
    ) {
      localSelectedservice?.push(newRowFieldConversion)
    }

    return localSelectedservice
  }

  const setCombinationInfo = async () => {
    let localSelectedService = deepCopy(fieldConversions)
    localSelectedService.splice(
      currentChange.idx,
      1,
      { ...localSelectedService[currentChange.idx] }
    );
    localSelectedService = addNewRow({ selectedServiceArg: localSelectedService });
    currentChange.field = 'InputFieldIndexDONE'
    setFieldConversions(localSelectedService)
  }
  useEffect(
    () => {
      if (currentChange.field === 'InputFieldIndex') {
        setCombinationInfo()
      }
    },
    [fieldConversions]
  )
  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    const localParsingRule = deepCopy(parsingRule)
    fieldConversions.splice(
      fieldConversions.length - 1,
      1
    )

    parsingRule.Options.FieldConversions = fieldConversions

    if (parmas?.id > 0) {


      dispatch(parsingRules.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/system/service/parsing-rules`, entity: 'parsingRules', jsonData: {

          Records: [
            parsingRule

          ]

        }
      })).then(() => {
        back()
      })

    } else {
      dispatch(parsingRules.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/system/service/parsing-rules`, entity: 'parsingRules', jsonData: {

          Records: [
            {
              ...localParsingRule,
              Id: 0,
              OwnerTypeId: localParsingRule?.OwnerTypeId || 0,
              Options: {
                FieldConversions: fieldConversions,
                InputFileType: localParsingRule?.Options?.InputFileType,
                OutputFileType: localParsingRule?.Options?.OutputFileType,
                InputFileHasHeader: localParsingRule?.Options?.InputFileHasHeader || false,


              },
              IsLimitedToOrganizationUnit: localParsingRule?.IsLimitedToOrganizationUnit || false,
              LimitedToOrganizationMappings: {
                LimitedToOrganizationUnitIds: Array.isArray(
                  localParsingRule?.LimitedToOrganizationMappings?.LimitedToOrganizationUnitIds
                )
                  ? localParsingRule?.LimitedToOrganizationMappings?.LimitedToOrganizationUnitIds
                  : [
                    localParsingRule?.LimitedToOrganizationMappings?.LimitedToOrganizationUnitIds
                  ].filter(Boolean)
              }
            }

          ]

        }
      })).then(() => {
        back()
      })
    }

  }

  const back = () => {
    navigate('/management/system/service/parsing-rules')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <ParsingRuleComponent
          handleInnerFormChange={handleInnerFormChange}
          parsingRule={parsingRule}
          handleFormSubmit={handleFormSubmit}
          back={back}
          deleteSelectedService={deleteSelectedService}
          handleFormItemChange={handleFormItemChange}
          handleInnerBasicFormChange={handleInnerBasicFormChange}
          organizationUnits={organizationUnitsLists?.result?.items}
          tenantFunctions={tenantfunctionsLists?.result?.items}
          fieldConversions={fieldConversions}
        />}
    </>
  )

}

export default ManagementParsingRule;